// Pantalla "¡Estás adentro!" tras sumarse a un partido abierto. Adaptada de ReservaSuccess (mismas clases
// `.success`, `.tick`, `.receipt`): sin consulta de estado ni QR porque el POST /join ya devuelve el partido
// actualizado. Muestra cuántos lugares faltan (o "Partido completo"), el link para compartir y el link de
// gestión (`/partidos/:id?token=`) que T11 resuelve como vista del jugador.
import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import RIcon from "../../reservas/components/ReservasIcons";
import { formatMatchDay, missingLabel, manageUrl } from "../openMatchesModel";
import ShareMatchButton from "./ShareMatchButton";
import "./OpenMatchCompact.css";

const OpenMatchJoinSuccess = ({ match, manageToken, shareLink }) => {
	const complete = Number(match.missing) === 0;
	return (
		<div className="success" data-testid="open-match-join-success">
			<div className="tick">
				<div className="ring">
					<RIcon name="check" width={38} height={38} />
				</div>
			</div>
			<h1>¡Estás adentro!</h1>
			{complete ? (
				<p className="ssub">
					<strong>Partido completo</strong>. La cancha quedó reservada.
				</p>
			) : (
				<p className="ssub">
					<strong>{missingLabel(match.missing)}</strong> para completar el partido. Compartilo para que se sume el resto.
				</p>
			)}

			{/* Same centered receipt as OpenMatchPublished (scoped rules in OpenMatchCompact.css). */}
			<div className="receipt open-match-receipt">
				<div className="receipt-top">
					<div>
						<div className="rt-name">{match.clubName}</div>
						{match.clubAddress && (
							<div className="rt-loc">
								<RIcon name="pin" width={14} height={14} />
								{match.clubAddress}
							</div>
						)}
					</div>
				</div>
				<div className="receipt-grid">
					<div className="rg">
						<div className="l"><RIcon name="cal" width={14} height={14} /> Fecha</div>
						<div className="v">{`${formatMatchDay(match.date)} ${dayjs(match.date).format("DD/MM")}`}</div>
					</div>
					<div className="rg">
						<div className="l"><RIcon name="clock" width={14} height={14} /> Horario</div>
						<div className="v">{match.slotStart} - {match.slotEnd} hs</div>
					</div>
					{match.courtName && (
						<div className="rg">
							<div className="l"><RIcon name="ticket" width={14} height={14} /> Cancha</div>
							<div className="v">{match.courtName}</div>
						</div>
					)}
				</div>
			</div>

			<p style={{ fontSize: 13, color: "#6b7280", fontWeight: 600 }}>
				Te avisamos por WhatsApp o email cuando se complete el partido o si hay cambios.
			</p>

			<div className="success-actions">
				<ShareMatchButton url={shareLink} className="r-btn-soft" />
				{manageToken && (
					<Link
						className="r-btn-primary"
						style={{ padding: "13px 28px", textDecoration: "none" }}
						to={manageUrl(match._id, manageToken, "")}
					>
						Ver mi partido
					</Link>
				)}
			</div>
		</div>
	);
};

export default OpenMatchJoinSuccess;
